import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Message from '../message/Message.js';

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    list: {
        margin: theme.spacing(0.5, 0, 0, 2.5),
        padding: 0,
        listStyleType: 'disc'
    },
    listItem: {
        margin: theme.spacing(0.5, 0)
    }
}));

/*
 * Lista, sempre visível, do que falta corrigir num bloco do formulário.
 * Usada onde o erro não tem um campo próprio para exibir a mensagem — por
 * exemplo nas tabelas de rendas, grupo familiar e parentes beneficiários.
 */
export default function ListaErros({ titulo = 'Corrija os itens abaixo para continuar', itens = [] }) {
    const classes = useStyles();

    if (!itens.length) {
        return null;
    }

    return (
        <div className={classes.root}>
            <Message type="error" variant="standard">
                <strong>{titulo}</strong>
                <ul className={classes.list}>
                    {itens.map((item, indice) => (
                        <li key={indice} className={classes.listItem}>{item}</li>
                    ))}
                </ul>
            </Message>
        </div>
    );
}

ListaErros.propTypes = {
    titulo: PropTypes.string,
    itens: PropTypes.arrayOf(PropTypes.string)
};
